import React from 'react';
import { defineMessages } from 'react-intl';
import { when } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter, RouteComponentProps } from 'react-router';

import withDialog from 'lib/alerts/with-dialog';
import { InfoDialog } from 'lib/alerts/dialog';

import { UserStore } from 'four-nets/user/user';
import { Product, Buyer } from 'four-nets/bazaar/bazaar';

export interface Props extends RouteComponentProps {
    product: Product;
    buyer: Buyer;
    userStore: UserStore;
    showDialog?: (dialog: any) => void;
}

@withDialog
@observer
class DeletedProductRedirectView extends React.Component<Props> {
    disposer?: (fn1: () => any, fn2: () => void) => void;

    componentDidMount() {
        const { product, userStore } = this.props;

        this.disposer = when(
            () => Boolean(product && userStore),
            () => {
                if (product.isHidden && !this.isInvolved()) {
                    const onOK = () => {
                        this.props.history.push('/market/');
                    };

                    this.props.showDialog!(
                        new InfoDialog({
                            message: userStore.intlManager.intl.formatMessage(
                                defineMessages({ BAZAAR_PRODUCT_WAS_DELETED: { id: 'BAZAAR_PRODUCT_WAS_DELETED' } })
                                    .BAZAAR_PRODUCT_WAS_DELETED
                            ),
                            onOK,
                            blocking: true,
                        })
                    );
                }
            }
        );
    }

    isInvolved = () => {
        return this.isAuthor() || this.isBuyer() || this.isSuperstaff();
    };

    isBuyer = () => {
        return !this.isAuthor() && this.props.buyer;
    };

    isAuthor = () => {
        return this.props.userStore.me && this.props.userStore.me === this.props.product.user;
    };

    isSuperstaff = () => {
        return this.props.userStore.me && this.props.userStore.me.isSuperstaff;
    };

    render() {
        return this.props.children;
    }
}

export default withRouter(DeletedProductRedirectView);
